module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<select ")
    ; __append( Html.attributes(attributes) )
    ; __append(" >\n    ")
    ;  if (showEmpty) { 
    ; __append("\n    <option value=\"\"></option>\n    ")
    ;  } 
    ; __append("\n\n    ")
    ;  if (source) { 
    ; __append("\n    ")
    ;  var keys = Object.keys(source) 
    ; __append("\n    ")
    ;  for (var i = 0; i < keys.length; i++) { 
    ; __append("\n    ")
    ; 
        var val = _.isObject(source[i]) ? source[i][value] : (source[i] || i);
        var titl = _.isObject(source[i]) ? source[i][title] : (source[i] || '');
        if (_.isArray(val) || _.isObject(val)) {
            val = JSON.stringify(val);
        }
    
    ; __append("\n    <option\n        value='")
    ; __append(escapeFn(val ))
    ; __append("'\n        ")
    ; __append( Html.selected(selected === val) )
    ; __append("\n    >\n        ")
    ; __append(escapeFn( titl ))
    ; __append("\n    </option>\n    ")
    ;  } 
    ; __append("\n    ")
    ;  } 
    ; __append("\n</select>\n")
  }
  return __output.join("");

}